import {observable,computed,runInAction,intercept} from 'mobx';
import InputModel from '../models/InputModel'
import SelectionModel from '../models/SelectionModel'
import OutputModel from "../models/OutputModel";
//mobx.configure({ enforceActions: true })
//import BrespaAnalyseStore from './BrespaAnalyseStore'
import {promisedComputed} from 'computed-async-mobx'
import Utils from "../utils/Utils";
import dwlogo from "../assets/images/logo.png";
import PrintOutput from "../models/PrintOutput";


class BaseEntriesStore {
    constructor(){
       // this.brespastore = BrespaAnalyseStore;
        const limit1 = intercept(this.stuetzweiteb1, "value", change => {
            change.newValue = Math.min(Math.max(change.newValue,1),10.5);
            return change;
        });
        const limit2 = intercept(this.stuetzweiteb2, "value", change => {
            change.newValue = Math.min(Math.max(change.newValue,1),10.5);
            return change;
        });
    }
    //@observable
    //brespastore = null;

    @observable eingabefelder = {};
    @observable daten = {};




    /*
    * Projektname:
PLZ und Bauort:
Anzahl Geschossdecken:
lichte Gebäudelänge L:
lichte Gebäudebreite B:
lichte Stützweite B1:
lichte Stützweite B2:
nur bei A3:
Anzahl der Felder B2
Gesamtdeckenfläche:
    *
    *
    *
    * */
    @observable projektname = new InputModel('Projektname, Bauort','Neues Projekt',null,false,false,null,true);
    @observable plz = new InputModel('Postleitzahl',29614,null,false,false,null,true);
    //@observable ort = new InputModel('Ort','Schneverdingen',null,false,false,null,true);
   // @observable entfernung = new InputModel('Entfernung',150,"km",true);
    @observable anzahldecken = new InputModel('Anzahl Geschossdecken',3,'');
    @observable geblaenge = new InputModel('Gebäudelänge',22,'m');
    @observable gebbreite = new InputModel('Gebäudebreite',12,'m');
    @observable stuetzweiteb1 = new InputModel('Stützweite Endfeld',6.4,'m');

    @observable stuetzweiteb2 = new InputModel('Stützweite Mittelfeld',6,'m');

    //@observable anzahlFelderB2 = new InputModel('Anzahl der Felder B2',3,null,true);
    strukturOptions = [
        {title:'Einfeld',value:{img:"einfeld.svg",type:"ef"}},
        {title:'Zweifeld',value:{img:"zweifeld.svg",type:"zf"}},
        {title:'Mehrfeld',value:{img:"mehrfeld.svg",type:"mf"}}
    ];

    @computed get print_entfernung() {return new PrintOutput("","" , Utils.rAndF(this._entfernungbck),"km",false,"","")};
    @computed get print_breite() {return new PrintOutput("","" , Utils.rAndF(this.gebbreite.value),"m",false,"","")};
    @computed get print_laenge () {return new PrintOutput("","" , Utils.rAndF(this.geblaenge.value),"m",false,"","")};
    @computed get print_geschosse () {return new PrintOutput("","" , this.anzahldecken.value,"",false,"","")};
    @computed get print_deckenfl () {
        let val = this.anzahldecken.value*this.geblaenge.value*this.gebbreite.value
        return new PrintOutput("","" , Utils.rAndF(val),"m²",false,"","")
    };
    @computed get print_stuetzweiteb1 () {return new PrintOutput("","" , Utils.rAndF(this.stuetzweiteb1.value),"m",false,"","")};
    @computed get print_stuetzweiteb2 () {return new PrintOutput("","" , Utils.rAndF(this.stuetzweiteb2.value),"m",false,"","")};
    @computed get totalDickeOb(){
        return new PrintOutput("","" , Utils.rAndF(this.dickeforderlichob.value),"cm",false,"","")
    }
    @computed get totalDickeHf(){
        return new PrintOutput("","" , Utils.rAndF(this.dickeforderlichhf.value),"cm",false,"","")

    }

    @observable strukturAuswahl = new SelectionModel("statisches System",SelectionModel.createOptionsFromObjectArray(this.strukturOptions),1,"",false,this.strukturSelected);
    @observable
    _entfernungbck = 17;
    skizzedatauri = null;
    @computed get print_name_plz_ort(){
        return new  PrintOutput(this.projektname.value + ", Bauort: "+ this.plz.value,"" , "","",false,"","");
    }
    @computed get name_plz_ort(){
        return new InputModel(this.projektname.value + ", Bauort: "+ this.plz.value,"","",false,false,null,true);
    }
    @computed get deckenflaeche(){
        let val = this.anzahldecken.value*this.geblaenge.value*this.gebbreite.value;
        return new OutputModel('Gesamtdeckenfläche','Gesamtdeckenfläche',val,'m²')
    }

    @computed get isPossible(){
        var retobj = {possible:false,reasons:[]}
        if(this.deckenflaeche.value < 500) {
            retobj.reasons.push("1");
        }
        if(this.entfernung.value > 400) {
            retobj.reasons.push("2");
        }
        retobj.possible = retobj.reasons.length == 0 ;
        return retobj;
    }

    strukturSelected = (selection)=>{
        if(selection.value.type == "ef"){
            this.stuetzweiteb1.title = "Stützweite";
            this.stuetzweiteb2.isHidden = true;
            this.stuetzweiteb2.value = this.stuetzweiteb1.value
        }else if(selection.value.type == "zf"){
            this.stuetzweiteb1.title = "Feld 1";
            this.stuetzweiteb2.title = "Feld 2";
            this.stuetzweiteb2.isHidden = false;
        }else{
            this.stuetzweiteb1.title = "Endfeld <sub>max</sub>";
            this.stuetzweiteb2.title = "Innenfeld <sub>max</sub>";
            this.stuetzweiteb2.isHidden = false;
        }
        Utils.getDataUri(`${process.env.PUBLIC_URL}/images/${this.strukturAuswahl.selectedOption.value.img}`,(uri)=>{this.skizzedatauri = uri});
    }


    entfpromise = promisedComputed(0, async () => {
        try{
        const response = await window.jQuery.post( "https://kunden.brasestruck.net/maxsell/dw/entfernung.php", { ziel: this.plz.value});
            const data = JSON.parse(response)
            console.log("received entfernung",data);

            if(data.code < 0){
                setTimeout(()=>{

                    alert(""+data.wert);

                },300);
                return 0;
            }
            setTimeout(()=>{
            this._entfernungbck = Math.round(data.wert);
                },100);

        return data.wert;
        }catch(e){
            console.error("error fetching distance",e);
            return 0;
        }

    });


    @computed get entfernung() {
        let val = Math.round(this.entfpromise.get());
        return new InputModel('Frachtentfernung',val,"km",true);

    }

    async fetchDistance(){
        try{
            const entf = await window.jQuery.$.post( "entfernung.php", { ziel: this.plz.value});
            console.log("received entfernung",entf);
        }catch(e){
            console.error("error fetching distance",e)
        }
    }

    async fetchData(){
        // this.state = "pending";
        try {
            const daten = await window.jQuery.get(`${process.env.PUBLIC_URL}/json/daten.json`);
            console.log("found daten:",daten)
            runInAction(() => {
                this.eingabefelder = daten.eingabefelder;
                this.daten = daten.daten;
            });
            for (let key in this.eingabefelder.basis) {
                if( daten.eingabefelder.basis.hasOwnProperty( key ) ) {
                   console.log("setting: ", key)
                    runInAction(() => {
                        this[key].value = daten.eingabefelder.basis[key].value;
                        this[key].einheit = daten.eingabefelder.basis[key].einheit;
                        this[key].disabled = !daten.eingabefelder.basis[key].editable;
                        this[key].title = daten.eingabefelder.basis[key].title;
                    });
                    //console.log("getting: ", this[key].value)
                }
            };
            this.detailEntries.push(this.detailEntries.pop())
            setTimeout(()=>{
               // this.lohnkosten.value = this.lohnkosten.value+0.1;
                //this.lohnkosten.value = this.lohnkosten.value-0.1;
                this.strukturSelected(this.strukturAuswahl.selectedOption);
                },200)
        }catch(e){
            console.error("error getting daten",e)
        }
    }


    @observable baustahlpreisStab = new InputModel('Baustahlpreis für Stabstahl',1,'');
    @observable baustahlpreisMatten = new InputModel('Baustahlpreis für Stahlmatten',1 ,'');
    @observable betonpreis = new InputModel('Betonpreis C20/25 inkl. Pumpe',1,'');
    @observable mietpreis = new InputModel('Mietkosten',1,'');
    @observable randschalung_eingabe = new InputModel('lfd. m Randschalung <br/>(20 bis 32 cm)',5,'€/lfd.m');
    @observable bewehrung_einbauen = new InputModel('Bewehrung BSt-Matten einbauen',1,'');
    @observable betonieren_transportbeton = new InputModel('Betonieren Transportbeton',1,'');
    @observable ruestzeiten_pumpe = new InputModel('Rüstzeiten Autobetonpumpe',1,'');
    @observable oberflaeche_abziehen = new InputModel('Oberfläche abziehen/glätten',1,'');
    @observable aussparungen_einbauen = new InputModel('Aussparungen ein- und ausbauen',1,'');
    @observable kosten_stuetzung = new InputModel('Kosten für zus. Stützung',1,'');
    @observable dickeforderlichhf = new InputModel("Erforderliche Dicke Halbfertigteil",1,"cm",true,false);
    @observable dickeforderlichob = new InputModel("Erforderliche Dicke Ortbeton",1,"cm",true,false);
    @observable dicke_erforderlich_brespa = new InputModel("Erforderliche Dicke Brespa",1,"cm",true,false);;





    @computed get totalDicke(){
        var out = new OutputModel("Erforderliche Dicke","Erforderliche Dicke",this.dickeforderlichhf.value,'cm');
        return out;
    }
    @computed get stellplaetze(){
        return  new InputModel('Stellplätze',this.parkfl / this.stellpfl,'Stück',false,false,this.setstellplaetze);
    }
    setstellplaetze = (v) => {
        console.log('ssets',v)
        this.parkpl = v;
    }
    @computed get parkflaeche(){
        return new InputModel('Parkfläche',this.parkpl*this.stellpfl,'m²',false,false,this.setparkflaeche);
    }
    setparkflaeche = (v)=>{
        console.log('set_pf',v)
        this.parkfl = v;
    };

    @computed get masgebendestuetzweite(){
        if(this.strukturAuswahl.value.type == "ef"){
            return this.stuetzweiteb1.value
        }
        if(this.strukturAuswahl.value.type == "zf"){
            return Math.max(0.85 * this.stuetzweiteb1.value, 0.85*this.stuetzweiteb2.value)
        }
        return Math.max(0.85 * this.stuetzweiteb1.value, 0.65*this.stuetzweiteb2.value)
    }
    @computed get erf_deckendicke(){
        let efd = ((Math.pow(this.masgebendestuetzweite,2)/150)*100) + 2.5;
        return Math.max(20,Math.round(efd));
    }




    @observable entries = [
        this.projektname,
        this.plz,
       // this.ort,
      //  this.entfernung

    ];
    @observable entries2 = [
        this.anzahldecken,
        this.geblaenge,
        this.gebbreite
    ];
    @observable entries3 = [

        this.stuetzweiteb1,
        this.stuetzweiteb2,
        this.strukturAuswahl
    ];
    @observable entries4 = [

        this.dickeforderlichhf,
        this.dickeforderlichob

    ];


    detailEntries = observable([

        this.baustahlpreisStab,
        this.baustahlpreisMatten,
        this.betonpreis,
      //  this.mietpreis,

        this.bewehrung_einbauen,
        this.betonieren_transportbeton,
        this.ruestzeiten_pumpe,
        this.oberflaeche_abziehen,
        this.aussparungen_einbauen,
        this.kosten_stuetzung,
        this.randschalung_eingabe
    ]);

}

export default new BaseEntriesStore();





// WEBPACK FOOTER //
// ./src/stores/BaseEntriesStore.js